import { Badge, Flex, Text } from "@radix-ui/themes";

import { Loader } from "@/components/ui/loader";
import { RegressionTestBySetId } from "@/v2/entities/regression/Regression.model";
import { formatDate } from "./utils";
import styles from "./styles.module.scss";

interface RunsViewProps {
  testRuns: RegressionTestBySetId[] | undefined;
  isLoading: boolean;
  selectedRunId: string | null;
  onSelectRun: (id: string) => void;
}

export function RunsView({
  testRuns,
  isLoading,
  selectedRunId,
  onSelectRun,
}: RunsViewProps) {
  return (
    <div className={styles.panelContent}>
      {isLoading ? (
        <div className={styles.loadingContainer}>
          <Loader />
        </div>
      ) : testRuns && testRuns.length > 0 ? (
        testRuns.map((run) => (
          <div
            key={run.id}
            className={`${styles.listItem} ${
              selectedRunId === run.id ? styles.selectedListItem : ""
            }`}
            onClick={() => onSelectRun(run.id)}
          >
            <Flex justify="between" align="center">
              <Text size="2">{formatDate(run.createdAt)}</Text>
              <Flex align="center" gap="2">
                {run.avgAccuracy != null && (
                  <Badge
                    size="1"
                    color={
                      run.avgAccuracy >= 0.8
                        ? "green"
                        : run.avgAccuracy >= 0.5
                        ? "orange"
                        : "red"
                    }
                  >
                    {Math.round(run.avgAccuracy * 100)}%
                  </Badge>
                )}
              </Flex>
            </Flex>
          </div>
        ))
      ) : (
        <div className={styles.emptyState}>
          <Text size="2" color="gray">
            No test runs yet
          </Text>
        </div>
      )}
    </div>
  );
}
